import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvService } from 'src/app/env.service';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
  logo: string;
  backUrl: string;

  token: boolean = false;

  constructor(
    private env: EnvService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {
    this.logo = this.env.logoName;

    this.activatedRoute.queryParams.subscribe((params) => {
      this.backUrl = params.backUrl;
    });

    if (this.authenticationService.currentToken) {
      this.token = true;
    }
  }

  ngOnInit(): void {}

  goBack() {
    this.router.navigate(this.backUrl ? [this.backUrl] : ['/app']);
  }
}
